import { Link } from "react-router-dom";
import { JOYSPOT_QUIZ_URL } from "@/lib/constants";

const A = "/brand";
const btnPrimary =
  "inline-flex items-center justify-center gap-2 bg-[#FF5A4F] text-white rounded-[10px] px-6 py-3 text-sm font-medium hover:bg-[#e8463c] transition-colors";

export function HomeHero() {
  return (
    <section
      data-testid="hero-section"
      className="relative w-full overflow-hidden"
      style={{ minHeight: "min(70vh, 600px)" }}
    >
      <img
        src="https://customer-assets.emergentagent.com/job_0b8a0be5-cf51-4ddc-a01c-90f98936e7b3/artifacts/06l07e45_Crop%20Hero%20Image%20to%20Hide%20Ring.png"
        alt="Lara leaning on couch, inviting smile. Pops of color."
        data-testid="hero-image"
        className="absolute inset-0 w-full h-full object-cover object-[80%_center] md:object-[50%_center]"
      />
      <div
        aria-hidden
        className="absolute inset-0"
        style={{
          background:
            "linear-gradient(100deg, rgba(28,25,23,0.64) 0%, rgba(28,25,23,0.51) 35%, rgba(28,25,23,0.25) 60%, rgba(28,25,23,0.05) 85%)",
        }}
      />
      <div
        aria-hidden
        className="absolute inset-0 md:hidden"
        style={{ background: "rgba(28,25,23,0.29)" }}
      />
      <div className="relative z-[2] max-w-7xl mx-auto px-6 md:px-10 py-16 md:py-20 min-h-[inherit] flex items-center">
        <div className="max-w-2xl reveal text-white">
          <h1
            data-testid="hero-headline"
            className="font-display text-[37px] sm:text-6xl lg:text-[65px] leading-[1.05] tracking-tight text-white"
          >
            You don't need to reinvent your life.
          </h1>
          <p className="mt-8 text-lg md:text-xl leading-relaxed max-w-xl text-white/90">
            You grabbed the "fine" blueprint somewhere along the way.
            <br />
            Now you've outgrown it.
          </p>
          <p className="mt-6 font-display text-xl md:text-2xl max-w-xl leading-snug text-white">
            You don't have to fix yourself. You need alignment.
          </p>
          <div className="mt-10 flex flex-col sm:flex-row sm:items-center gap-4">
            <a href={JOYSPOT_QUIZ_URL} data-testid="hero-cta-joyspot" className={btnPrimary}>
              Find Your JOYspot™
            </a>
            <Link
              to="/work-with-me"
              data-testid="hero-cta-workshop"
              className="text-white text-sm font-medium hover:text-[#F6A041] underline-offset-4 hover:underline"
            >
              Join a Vision Book Workshop →
            </Link>
          </div>
          <p className="mt-5 text-sm text-white/80">
            Take the 3-minute quiz to discover your JOYspot™ Archetype.
          </p>
        </div>
      </div>
    </section>
  );
}
